import type { FirebaseApp } from "firebase/app";

let plannerFirebaseApp: FirebaseApp | null = null;

/** Bind the platform Firebase app before calling getPlannerModel / runWebSearch. */
export function setPlannerFirebaseApp(app: FirebaseApp): void {
  plannerFirebaseApp = app;
}

export function getPlannerFirebaseApp(): FirebaseApp {
  if (!plannerFirebaseApp) {
    throw new Error(
      "Planner Firebase app not set — call setPlannerFirebaseApp() at app bootstrap.",
    );
  }
  return plannerFirebaseApp;
}
